import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';
import { saveAs } from 'file-saver';
import { QualityService } from 'app/shared/services/quality.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'quality-by-supply-component',
  templateUrl: './quality-by-supply.component.html',
  styleUrls: ['./quality-by-supply.component.scss'],
})
export class QualityBySupplyComponent implements OnInit {
  public queryParams: any;
  public data: Array<any>;
  public dataTotal: any;
  public dataBySupplyByDemand: any;
  public dataBySupplyByDemandTotal: any;
  public dataBySupplyByDomain: any;
  public dataBySupplyByDomainTotal: any;
  public columnsDemandMoat: Array<any>;
  public columnsDomainMoat: Array<any>;
  public currPluginPartner: number;
  public supplyId: any;
  public supplies: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public isExporting: boolean;
  public startDate: Date;
  public selectedTab: number;
  public endDate: Date;
  public reportParams: any;
  public loadedReports: Array<any>;
  public currPage: number;
  public filters: any;
  public sorting: any;
  public itemsPerPage: number;
  public numOfPages: number;
  public totalAmount: number;
  public linkColumns: Array<string>;
  public currSubscription: any;
  public currTotalsSubscription: any;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public dictionaryService: DictionaryService,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public httpService: HttpService,
    public gridService: GridService,
    public qualityService: QualityService,
    public ga: GoogleAnalyticsService,
    public userService: UserService
  ) {
    this.data = [];
    this.dataTotal = {};
    this.dataBySupplyByDemand = [];
    this.dataBySupplyByDemandTotal = [];
    this.dataBySupplyByDomain = [];
    this.dataBySupplyByDomainTotal = [];
    this.supplies = [];
    this.isLoading = false;
    this.isError = false;
    this.isExporting = false;
    this.currPage = 1;
    this.filters = {};
    this.sorting = {};
    this.itemsPerPage = 50;
    this.numOfPages = 0;
    this.totalAmount = 0;
    this.linkColumns = [];
    this.columnsDemandMoat = [
      { key: 'vastId', label: 'DEMAND_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'DEMAND_NAME', filterType: 'INPUT', width: 200 },
      {
        key: 'vast_type',
        label: 'DEMAND_TYPE',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseDemandType,
        parseTooltipFunction: this.gridService.parseDemandType,
      },
      {
        key: 'adStarts',
        label: 'IMPRESSIONS',
        tooltipKey: 'REPORT_TOOLTIP_I',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'revenue',
        label: 'REVENUE',
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measureFilter: true,
        filterType: 'RANGE',
        char: '$',
        align: 'left',
        defaultVisibility: false,
      },
      {
        key: 'total',
        tooltipKey: 'SAMPLED_IMPRESSIONS_TT',
        label: 'SAMPLED_IMPRESSIONS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'ivt_measurable',
        tooltipKey: 'IVT_MEASURABLE',
        label: 'IVT_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_measurable_rate',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'ivt',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_rate',
        tooltipKey: 'IVT_PERCENTAGE_TT',
        label: 'IVT_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'data_center_traffic',
        label: 'DATA_CENTER_TRAFFIC',
        tooltipKey: 'DATA_CENTER_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'old_browser',
        label: 'OLD_BROWSER',
        tooltipKey: 'OLD_BROWSER',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'proxy_traffic',
        label: 'PROXY_TRAFFIC',
        tooltipKey: 'PROXY_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'viewability_analyzed',
        label: 'VIEWABILITY_ANALYZED',
        tooltipKey: 'VIEWABILITY_ANALYZED',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable',
        tooltipKey: 'VIEWABILITY_MEASURABLE',
        label: 'VIEWABILITY_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable_rate',
        tooltipKey: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        label: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'viewability',
        tooltipKey: 'VIEWABILITY',
        label: 'VIEWABILITY',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_rate',
        label: 'VIEWABILITY_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'hover',
        tooltipKey: 'HOVERS',
        label: 'HOVERS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'hover_percent',
        tooltipKey: 'HOVERS_PERCENT_TT',
        label: 'HOVERS_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
    ];
    this.columnsDomainMoat = [
      { key: 'domain', label: 'DOMAIN', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'DEMAND_NAME', filterType: 'INPUT', width: 200 },
      {
        key: 'opportunities',
        label: 'OPPORTUNITIES',
        tooltipKey: 'OPPORTUNITIES_TT',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: true,
        filterType: 'RANGE',
      },
      {
        key: 'adStarts',
        label: 'IMPRESSIONS',
        tooltipKey: 'REPORT_TOOLTIP_I',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'revenue',
        label: 'REVENUE',
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measureFilter: true,
        filterType: 'RANGE',
        char: '$',
        align: 'left',
        defaultVisibility: false,
      },
      {
        key: 'total',
        tooltipKey: 'SAMPLED_IMPRESSIONS_TT',
        label: 'SAMPLED_IMPRESSIONS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'ivt_measurable',
        tooltipKey: 'IVT_MEASURABLE',
        label: 'IVT_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_measurable_rate',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'ivt',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_rate',
        tooltipKey: 'IVT_PERCENTAGE_TT',
        label: 'IVT_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'data_center_traffic',
        label: 'DATA_CENTER_TRAFFIC',
        tooltipKey: 'DATA_CENTER_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'old_browser',
        label: 'OLD_BROWSER',
        tooltipKey: 'OLD_BROWSER',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'proxy_traffic',
        label: 'PROXY_TRAFFIC',
        tooltipKey: 'PROXY_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'viewability_analyzed',
        label: 'VIEWABILITY_ANALYZED',
        tooltipKey: 'VIEWABILITY_ANALYZED',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable',
        tooltipKey: 'VIEWABILITY_MEASURABLE',
        label: 'VIEWABILITY_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable_rate',
        tooltipKey: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        label: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'viewability',
        tooltipKey: 'VIEWABILITY',
        label: 'VIEWABILITY',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_rate',
        label: 'VIEWABILITY_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'hover',
        tooltipKey: 'HOVERS',
        label: 'HOVERS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'hover_percent',
        tooltipKey: 'HOVERS_PERCENT_TT',
        label: 'HOVERS_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
    ];
    this.initLoadedReportsData();
    this.subscriptions = [];
    this.subscriptions.push(
      this.route.queryParams.subscribe(
        (queryParams: any) => {
          // Store the query params
          this.queryParams = _.cloneDeep(queryParams);
          // Supply ID
          this.supplyId = location.pathname.split(/[\s/]+/).pop();

          // Start and end date
          const dates: any = {};
          let startDateStr = '';
          let endDateStr = '';
          if (this.queryParams.sd && this.queryParams.ed) {
            startDateStr = this.queryParams.sd;
            endDateStr = this.queryParams.ed;
          } else if (!this.sharedService.isEmpty(localStorage.getItem('selectedDates'))) {
            const savedDates: any = JSON.parse(localStorage.getItem('selectedDates'));
            startDateStr = savedDates.startDate;
            endDateStr = savedDates.endDate;
          }

          this.startDate = this.sharedService.stringToESTDate(startDateStr);
          this.endDate = this.sharedService.stringToESTDate(endDateStr);
          dates.startDate = this.startDate;
          dates.endDate = this.endDate;
          localStorage.setItem('selectedDates', JSON.stringify(dates));

          // Plugin partner
          this.currPluginPartner = this.qualityService.pluginPartners[0].id;
          if (this.queryParams.partner) {
            if (!isNaN(Number(this.queryParams.partner))) {
              this.currPluginPartner = parseInt(this.queryParams.partner);
              if (!_.map(this.qualityService.pluginPartners, 'id').includes(this.currPluginPartner)) {
                this.currPluginPartner = this.qualityService.pluginPartners[0].id;
              }
            }
          }
          // Selected tab
          this.selectedTab = 0;
          if (this.queryParams.tab) {
            if (!isNaN(Number(this.queryParams.tab))) {
              this.selectedTab = parseInt(this.queryParams.tab);
              if (this.currPluginPartner === 4) {
                if (this.selectedTab !== 0 && this.selectedTab !== 1) {
                  this.selectedTab = 0;
                }
              }
            }
          }
          // Page
          if (this.queryParams.p) {
            this.currPage = !this.sharedService.isEmpty(this.queryParams.p) ? parseInt(this.queryParams.p) : 1;
          } else {
            this.currPage = 1;
          }

          // Network id
          if (this.queryParams.nid) {
            // If this is an admin user
            if (this.userService.isAdmin()) {
              // Find the relevant network
              const network = _.find(this.sharedService.activeNetworks, { networkId: this.queryParams.nid });
              // If the network exists...
              if (network) {
                // If the query params network ID is not the current network ID...
                if (network.networkId.toString() !== this.userService.networkData.networkId.toString()) {
                  // Change the network, and once it's finished, parse the query params again (will just get the report this time)
                  this.userService.changeNetwork(network, true).subscribe(() => {
                    this.clearDataAndLoadReports(this.supplyId);
                  });
                  // Prevent the report from being fetched, as we first of all want to switch to the new network
                  return;
                }
              }
            } else {
              // Delete the parameter
              delete this.queryParams.nid;
              // Reroute to the same URL, without the network ID parameter
              this.router.navigate([], { queryParams: this.queryParams }).then(() => {
                return;
              });
              // Prevent the report from being fetched, as we first of all want to delete the 'nid' parameter
              return;
            }
          }

          // Get report
          this.getQualityBySupplyReport(this.supplyId);
        },
        () => {
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.supplies = [];
          this.getAllSupplies();
          this.clearDataAndLoadReports(this.supplyId);
        }
      })
    );
    this.sharedService.setPageTitle('QUALITY_AND_VIEWABILITY');
    this.getAllSupplies();
  }

  clearDataAndLoadReports(_supplyId: number) {
    this.initLoadedReportsData();
    this.currPage = 1;
    if (!_supplyId) {
      _supplyId = this.supplyId;
    }
    this.getQualityBySupplyReport(_supplyId);
  }

  // Get the data for the grid-tabs
  getTabsData() {
    return [{ title: this.dictionaryService.get('BY_DEMAND') }, { title: this.dictionaryService.get('BY_DOMAIN') }];
  }

  // Initialize loaded reports data
  initLoadedReportsData() {
    this.loadedReports = [];
    this.qualityService.pluginPartners.forEach((partner: any) => {
      this.loadedReports[partner.id] = [];
      this.getTabsData().forEach((tab: any, tabIndex: number) => {
        this.loadedReports[partner.id][tabIndex] = {
          data: false,
          totals: false,
        };
      });
    });
  }

  // Get columns
  getColumnsSettings() {
    switch (this.selectedTab) {
      case 0:
        return this.getDemandColumns();
      case 1:
        return this.getDomainColumns();
      default:
        return [];
    }
  }

  // Get columns: supply-by-demand
  getDemandColumns() {
    if (this.currPluginPartner === 4) {
      return this.columnsDemandMoat;
    }
  }

  // Get columns: supply-by-domain
  getDomainColumns() {
    if (this.currPluginPartner === 4) {
      return this.columnsDomainMoat;
    }
  }

  getQualityBySupplyReport(_supplyId: number) {
    this.linkColumns = [];
    const queryParams: any = {};
    this.supplyId = _supplyId;
    // if (!this.isLoading) {
    this.isLoading = true;
    this.reportParams = {
      quality_type: this.currPluginPartner,
      playerId: this.supplyId,
      active: '1',
      startDate: moment(this.startDate).format('ddd MMM DD YYYY 00:00:00'),
      endDate: moment(this.endDate).format('ddd MMM DD YYYY 23:59:59'),
      filters: this.parseFilters(),
      sorting: this.sorting,
      page: this.currPage,
      amountPerPage: this.itemsPerPage,
      is_desktop: 0,
      is_mobile_web: 0,
      is_mobile_app: 0,
    };
    if (this.sorting.attrName) {
      if (_.find(this.getColumnsSettings(), { key: this.sorting.attrName })) {
        this.reportParams.sorting = this.sorting;
      } else {
        this.sorting = {};
      }
    }
    this.onEnvironmentFilterChange();
    queryParams.sd = moment(this.startDate).format('YYYY-MM-DD').toString();
    queryParams.ed = moment(this.endDate).format('YYYY-MM-DD').toString();
    queryParams.partner = this.currPluginPartner;
    queryParams.tab = this.selectedTab;
    this.router.navigate([`/quality/supply/${this.supplyId}`], { queryParams: queryParams }).then(() => {
      return;
    });
    this.loadReport();
    // }
  }

  onError() {
    this.isLoading = false;
    this.isError = true;
    this.currSubscription = null;
    this.currTotalsSubscription = null;
  }

  // Export all data
  exportAll() {
    let path = '';
    let reportParams: any;
    if (this.selectedTab === 0) {
      path = 'getQualityReportPlayerByVast';
    } else if (this.selectedTab === 1) {
      path = 'getQualityReportPlayerByDomain';
    } else {
      return;
    }
    this.isExporting = true;
    reportParams = _.cloneDeep(this.reportParams);
    delete reportParams.amountPerPage;
    this.subscriptions.push(
      this.httpService.post('reports_csv_export/' + path, reportParams).subscribe(
        (response: any) => {
          const blob = new Blob([response.data], { type: 'text/csv; charset=utf-8' });
          saveAs(blob, this.dictionaryService.get('EXPORTED_DATA') + '.csv');
          this.isExporting = false;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        },
        () => {
          this.isExporting = false;
          this.isError = true;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        }
      )
    );
  }

  // Parse filters
  parseFilters() {
    const filters: any = _.cloneDeep(this.filters);
    if (filters.player_type) {
      if (filters.player_type.length > 0) {
        filters.player_type = filters.player_type[0];
      }
    }
    if (filters.vast_type) {
      if (filters.vast_type.length > 0) {
        filters.vast_type = filters.vast_type[0];
      }
    }
    if (filters.revenue) {
      if (filters.revenue.hasOwnProperty('min') && filters.revenue.min !== null) {
        filters.revenue.min = parseFloat(filters.revenue.min.toString().replace(/[^0-9.]/g, ''));
      }
      if (filters.revenue.hasOwnProperty('max') && filters.revenue.max !== null) {
        filters.revenue.max = parseFloat(filters.revenue.max.toString().replace(/[^0-9.]/g, ''));
      }
    }
    delete filters.environment;
    return filters;
  }

  getSupply() {
    const item: any = _.find(this.supplies, { value: +this.supplyId });
    let index = -1;
    if (item) {
      index = this.supplies.indexOf(item);
      if (index !== -1) {
        return index;
      }
    }
    return index;
  }

  getAllSupplies() {
    this.isLoading = true;
    this.subscriptions.push(
      this.httpService.post('vdsp_ws/getSupplies', { withAmount: 0 }).subscribe(
        (response: any) => {
          let data: Array<any> = response;
          data = _.sortBy(data, (o) => o.name);
          this.supplies = [];
          for (let i = 0; i < data.length; i++) {
            this.supplies.push({ label: data[i].name, value: +data[i].playerId });
          }
        },
        () => {
          // Display the error message
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }

  initByDemandData() {
    this.currSubscription = this.httpService
      .post('quality_report/getQualityReportPlayerByVast', this.reportParams)
      .subscribe(
        (response: any) => {
          const data: Array<any> = response.data.data;
          this.totalAmount = +response.data.paginator.totalAmount;
          this.numOfPages = +response.data.paginator.totalAmountOfPages;
          this.dataBySupplyByDemand = data;
          this.onReportLoaded(0, 'data');
        },
        () => {
          this.onError();
        }
      );

    this.currTotalsSubscription = this.httpService
      .post('report_totals/getQualityReportByPlayerByVastTotals', this.reportParams)
      .subscribe(
        (response: any) => {
          this.dataBySupplyByDemandTotal = response.data[0];
          this.onReportLoaded(0, 'totals');
        },
        () => {
          this.onError();
        }
      );
    this.subscriptions.push(this.currSubscription);
    this.subscriptions.push(this.currTotalsSubscription);
  }

  initByDomainData() {
    this.currSubscription = this.httpService
      .post('quality_report/getQualityReportPlayerByDomain', this.reportParams)
      .subscribe(
        (response: any) => {
          const data: Array<any> = response.data.data;
          this.totalAmount = parseInt(response.data.paginator.totalAmount);
          this.numOfPages = parseInt(response.data.paginator.totalAmountOfPages);
          this.dataBySupplyByDomain = data;
          this.onReportLoaded(1, 'data');
        },
        () => {
          this.onError();
        }
      );

    this.currTotalsSubscription = this.httpService
      .post('report_totals/getQualityReportByPlayerDomainTotals', this.reportParams)
      .subscribe(
        (response: any) => {
          this.dataBySupplyByDomainTotal = response.data[0];
          this.onReportLoaded(1, 'totals');
        },
        () => {
          this.onError();
        }
      );
    this.subscriptions.push(this.currSubscription);
    this.subscriptions.push(this.currTotalsSubscription);
  }

  // On report loaded
  onReportLoaded(tab: number, type: string) {
    let currReportLoaded: any;
    let n: number;
    this.data = [];
    this.loadedReports[this.currPluginPartner][tab][type] = true;
    currReportLoaded = this.loadedReports[this.currPluginPartner][tab];
    if (currReportLoaded.data && currReportLoaded.totals) {
      // Dummy items for previous pages
      for (let i = 1; i < this.currPage; i++) {
        for (let j = 0; j < this.itemsPerPage; j++) {
          this.data.push({});
        }
      }
      switch (this.selectedTab) {
        case 0:
          this.data = this.data.concat(_.cloneDeep(this.dataBySupplyByDemand));
          this.dataTotal = _.cloneDeep(this.dataBySupplyByDemandTotal);
          break;
        case 1:
          this.data = this.data.concat(_.cloneDeep(this.dataBySupplyByDomain));
          this.dataTotal = _.cloneDeep(this.dataBySupplyByDomainTotal);
          break;
      }
      // Dummy items for next pages
      for (let i: number = this.currPage; i < this.numOfPages; i++) {
        n = i + 1 < this.numOfPages ? this.itemsPerPage : this.totalAmount - (this.numOfPages - 1) * this.itemsPerPage;
        for (let j = 0; j < n; j++) {
          this.data.push({});
        }
      }
      this.isLoading = false;
      this.currSubscription = null;
      this.currTotalsSubscription = null;
    }
  }

  loadReport() {
    const currReportLoaded: any = this.loadedReports[this.currPluginPartner][this.selectedTab];
    if (!currReportLoaded.data || !currReportLoaded.totals) {
      this.isLoading = true;
      this.sharedService.sendMessage('GRID_DETECT_CHANGES');
      if (this.currSubscription) {
        this.currSubscription.unsubscribe();
      }
      if (this.currTotalsSubscription) {
        this.currTotalsSubscription.unsubscribe();
      }
      switch (this.selectedTab) {
        case 0:
          this.initByDemandData();
          break;
        case 1:
          this.initByDomainData();
          break;
      }
    } else {
      this.onReportLoaded(this.selectedTab, 'data');
    }
  }

  getDates() {
    const dates = {};
    dates['sd'] = moment(this.startDate).format('YYYY-MM-DD').toString();
    dates['ed'] = moment(this.endDate).format('YYYY-MM-DD').toString();
    return dates;
  }

  // On tab selected
  onTabSelected($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    queryParams.tab = $event;
    this.router.navigate([], { queryParams: queryParams }).then(() => {
      return;
    });
  }

  //environment filter change
  onEnvironmentFilterChange() {
    switch (this.filters.environment) {
      case this.dictionaryService.get('DESKTOP'):
        this.reportParams.is_desktop = 1;
        this.reportParams.is_mobile_web = 0;
        this.reportParams.is_mobile_app = 0;
        break;
      case this.dictionaryService.get('MOBILE_WEB'):
        this.reportParams.is_desktop = 0;
        this.reportParams.is_mobile_web = 1;
        this.reportParams.is_mobile_app = 0;
        break;
      case this.dictionaryService.get('MOBILE_APP'):
        this.reportParams.is_desktop = 0;
        this.reportParams.is_mobile_web = 0;
        this.reportParams.is_mobile_app = 1;
        break;
    }
  }

  // On filter change
  onFilterChange($event: any) {
    this.filters = _.cloneDeep($event);
    this.initLoadedReportsData();
    this.clearDataAndLoadReports(this.supplyId);
  }

  // On sort change
  onSortChange($event: any) {
    this.sorting = {
      attrName: $event.sortCell,
      sort: $event.sortDir,
    };
    this.initLoadedReportsData();
    this.clearDataAndLoadReports(this.supplyId);
  }

  // On pagination
  onPagination($event: any) {
    this.initLoadedReportsData();
    this.currPage = $event;
    this.getQualityBySupplyReport(this.supplyId);
  }

  // Handle a 'start-date-changed' event from the datepicker component
  startDateChanged($event: any) {
    this.startDate = $event;
  }

  // Handle an 'end-date-changed' event from the datepicker component
  endDateChanged($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    this.endDate = $event;
    if (this.endDate !== null) {
      this.initLoadedReportsData();
      this.currPage = 1;
      queryParams.sd = moment(this.startDate).format('YYYY-MM-DD').toString();
      queryParams.ed = moment(this.endDate).format('YYYY-MM-DD').toString();
      this.router.navigate([], { queryParams: queryParams }).then(() => {
        return;
      });
    }
  }
}
